<template>
<div class="chapter">
<div class="inner_page">
<a id="page_x"></a>
<h2 class="fmtitle">List of Maps and Diagrams</h2>
<p class="abb"><span class="abb_hang">Figure 1</span> Trade routes through Ancient Palestine</p>
<p class="abb"><span class="abb_hang">Figure 2</span> The City of David on the Ophel</p>
<p class="abb"><span class="abb_hang">Figure 3</span> Extension of the city onto Mt Moriah</p>
<p class="abb"><span class="abb_hang">Figure 4</span> Palestine’s Separate Kingdoms (late tenth century bce)</p>
<p class="abb"><span class="abb_hang">Figure 5</span> Kings of Judah and Israel during the early and mid-ninth century bce</p>
<p class="abb"><span class="abb_hang">Figure 6</span> Hezekiah’s late eighth century bce expansion onto Jerusalem’s Western Hill</p>
<p class="abb"><span class="abb_hang">Figure 7</span> Palestine c.701 <span class="smallcaps">BCE</span></p>
<p class="abb"><span class="abb_hang">Figure 8</span> Josiah and his successors</p>
<p class="abb"><span class="abb_hang">Figure 9</span> Zerubbabel’s Davidic lineage</p>
<p class="abb"><span class="abb_hang">Figure 10</span> Nehemiah’s Jerusalem</p>
<p class="abb"><span class="abb_hang">Figure 11</span> The Seleucid kings 321–164 <span class="smallcaps">BCE</span></p>
<p class="abb"><span class="abb_hang">Figure 12</span> The Sons of Mattathias Asamonaeus</p>
<p class="abb"><span class="abb_hang">Figure 13</span> The Seleucid kings 223–125 <span class="smallcaps">BCE</span></p>
<p class="abb"><span class="abb_hang">Figure 14</span> The Hasmonean Dynasty</p>
<p class="abb"><span class="abb_hang">Figure 15</span> <em class="italic">The First Wall</em></p>
<p class="abb"><span class="abb_hang">Figure 16</span> <em class="italic">The Second Wall</em></p>
<p class="abb"><span class="abb_hang">Figure 17</span> Herod’s family (excluding his children and their mothers)</p>
<p class="abb"><span class="abb_hang">Figure 18</span> Herod’s Jerusalem c.18 <span class="smallcaps">BCE</span></p>
<p class="abb"><span class="abb_hang">Figure 19</span> Herod II (the Great) 72–4 <span class="smallcaps">BCE</span> His children, their mothers and selected offspring</p>
<p class="abb"><span class="abb_hang">Figure 20</span> Jerusalem c.70 ce</p>
<p class="abb"><span class="abb_hang">Figure 21</span> Aelia Capitolina</p>
<p class="abb"><span class="abb_hang">Figure 22</span> Jerusalem’s Byzantine churches x</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List.vue?630293c4